import './product-view.component.pug'
import './product-view.component.scss'
if (document.querySelector('.product-view')) {
  import(
    /* webpackChunkName: "product-view-chunk" */ './product-general/index.js'
  )
}
